import React, { Component } from "react";
import { Image, PrimaryButton } from "@fluentui/react";
import ZoomLogo from "../../../assets/images/zoom-logo.png";
import api from "../helpers/api-services";
import { AppPageTitle } from "./app-page-title";
import IntlUtil from "../helpers/intl-util";
import PageUtil from "../helpers/page-util";
import PageHeader from "../../pages/common/helpers/page-header";
import Navbar from "../../pages/common/components/navbar";
import { accessLogWithToken, checkIdentitySession } from "../actions/identity-actions";
import { AppURLProps } from "../settings/app-urls";
import UserConsent from "../../pages/common/components/user-consent";
import TokenUtil from "../helpers/token-util";
import {
  acceptAppConsent,
  getAppConsent,
  setUserConsentRecord,
} from "../../pages/common/actions/general-actions";
import { getAppInsights } from "../settings/azure-insights-config";
import { UniversalConnecterConstants } from "../../pages/common/settings/universal-connecter-constants";
import { AppConfigProps } from "../settings/app-config";
import { connect } from "react-redux";
import PageLoader from "../../pages/common/helpers/page-loader";

class ZoomSignin extends Component {
  _intl_ns_suc_home = "signin";
  _intl_ns_common = "suc_common";

  _isMounted = false;
  _axiosSource = api.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _azureInsights = getAppInsights();

  constructor(props) {
    super(props);
    this.state = {
      isAppDataFetched: false,
      isConsentAccepted: true,
      userConsentRecord: null,
      isConsentSubmitted: false,
    };
  }
  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };
  async componentDidMount() {
    this._isMounted = true;
    PageUtil.scrollToTop();
    let isSessisonValid = false;
    isSessisonValid = checkIdentitySession();
    if (isSessisonValid === false) {
      return this.props.history.push(AppURLProps.signin);
    } else {
      await this.setStateAsync({
        isAppDataFetched: false,
      });
      await this.fetchAppConsent();
      await this.setStateAsync({
        isAppDataFetched: true,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }
  fetchAppConsent = async () => {
    await getAppConsent(this._cancelToken)
      .then(async (res) => {
        if (
          res &&
          res.status === AppConfigProps.httpStatusCode.ok &&
          res?.data?.result
        ) {
          let record = res.data.result;
          let isConsentAccepted =
            record.processStatus?.toLowerCase().trim() ===
              UniversalConnecterConstants.GENERAL.CONSENT_STATUS.NOT_ACCEPTED?.toLowerCase().trim()
              ? false
              : true;

          await this.props.setUserConsentRecord(record);
          await this.setStateAsync({
            userConsentRecord: record,
            isConsentAccepted: isConsentAccepted,
            isUserConsentModalOpen: isConsentAccepted ? false : true,
          });
        } else {
          await this.props.setUserConsentRecord(null);

          await this.setStateAsync({
            isConsentAccepted: true,
          });
        }
      })
      .catch(async (err) => {
        let azureInsights = getAppInsights();

        azureInsights?.trackException(err);
        await this.setStateAsync({
          isPageDataFetched: true,
          isAppDataFetched: true,
        });
      });
  };
  loadZoomSigninPage = () => {
    let isSessisonValid = false;
    isSessisonValid = checkIdentitySession();
    if (isSessisonValid === true) {
      const clientId = process.env.REACT_APP_ZOOM_CLIENT_ID;
      const thisUrl = new URL(process.env.REACT_APP_ZOOM_AUTH_URL);
      thisUrl.searchParams.set("response_type", "code");
      thisUrl.searchParams.set("client_id", clientId);
      thisUrl.searchParams.set(
        "redirect_uri",
        window.location.origin + "/zoom-authenticate"
      );
      window.location.href = thisUrl.href;
    } else {
      let token = TokenUtil.getIdentitySippioAccessToken();
      console.log(token);
      if (token && token !== "") {
        accessLogWithToken(
          AppURLProps.zoomAuthenticate,
          "UID-SIF",
          "Sign-in Failure",
          token
        );
      }
      return this.props.history.push(AppURLProps.signin);
    }
  };

  handleConsentSubmit = async () => {
    await this.setStateAsync({ isConsentSubmitted: true });
    let tokenData = TokenUtil.getIdentitySippioAccessTokenData();
    let userConsent = {
      consentId: this.state.userConsentRecord.consentId,
      userEmail: tokenData.userEmail,
      accountNumber: tokenData.accountNumber,
      processStatus:
        UniversalConnecterConstants.GENERAL.CONSENT_STATUS.ACCEPTED,
    };
    await acceptAppConsent(userConsent, this._cancelToken)
      .then(async (res) => {
        if (
          res &&
          res.status === AppConfigProps.httpStatusCode.ok &&
          res?.data?.result
        ) {
          if (this.props.userConsentData) {
            await this.props.setUserConsentRecord({
              ...this.props.userConsentData,
              acceptTimestamp: res.data.result?.acceptTimestamp,
              consentUserId: res.data.result?.consentUserId,
            });
          }
          await this.setStateAsync({
            isConsentAccepted: true,
            isConsentSubmitted: false,
          });
        } else {
          await this.setStateAsync({
            isConsentAccepted: true,
            isConsentSubmitted: false,
          });
        }
      })
      .catch(async (err) => {
        let azureInsights = getAppInsights();

        azureInsights?.trackException(err);
        if (this.props.userConsentData) {
          await this.props.setUserConsentRecord(null);
        }
        await this.setStateAsync({
          isConsentAccepted: true,
          isConsentSubmitted: false,
        });
      });
  };

  signout = async (e) => {
    //access log signout
    this.props.history.push(AppURLProps.signout);
  };
  handleConsentReject = async () => {
    await this.setStateAsync({
      isUserConsentModalOpen: false,
      isAppDataFetched: false,
    });
    await this.signout();
  };
  render() {
    return (
      <>
        <AppPageTitle
          pageTitle={IntlUtil.getText(
            this._intl_ns_suc_home,
            "title.zoomConnect"
          )}
        />
        <div id="suc-layout-wrapper">
          <Navbar {...this.props} />
          <div id="suc-main-wrapper">
            <div id="suc-main-content">
              <PageLoader
                type="full"
                label={IntlUtil.getText(
                  this._intl_ns_common,
                  "content.loading"
                )}
                status={this.state.isAppDataFetched}
              >
                <PageHeader />
                {this.state.isConsentAccepted === false ? (
                  <UserConsent
                    isUserConsentModalOpen={this.state.isUserConsentModalOpen}
                    isConsentSubmitted={this.state.isConsentSubmitted}
                    handleConsentAccept={this.handleConsentSubmit}
                    handleConsentReject={this.handleConsentReject}
                    userConsentRecord={this.state.userConsentRecord}
                  />
                ) : (
                  <div id="suc-page-container">
                    <div className="frame-content-zoom">
                      <div className="zoom-logo-wrapper m-b-20">
                        <Image src={ZoomLogo} />
                      </div>
                      <div className="zoom-text-wrapper m-l-20 m-r-20">
                        <span className="text-fw-regular">
                          {IntlUtil.getText(
                            this._intl_ns_suc_home,
                            "content.zoomInfoText1"
                          )}
                        </span>
                      </div>
                      {this.props.history.location.state &&
                          this.props.history.location.state?.isErrorOccurred === true ? (
                            <div className="zoom-text-wrapper m-t-20 m-r-20 m-l-20">
                              <span className="signin-error-text m-b-5">
                            {this.props.history.location.state?.errorMessage}
                          </span></div>
                        ) : null}
                      <div className="zoom-button-wrapper m-t-20 m-l-20 m-r-20">
                        <PrimaryButton
                          onClick={() => this.loadZoomSigninPage()}
                        >
                          {IntlUtil.getText(
                            this._intl_ns_suc_home,
                            "content.connectToZoom"
                          )}
                        </PrimaryButton>
                      </div>
                      <div className="zoom-text-wrapper m-t-20 m-r-20 m-l-20">
                        <span className="text-fw-regular">
                          {IntlUtil.getText(
                            this._intl_ns_suc_home,
                            "content.zoomInfoText2"
                          )}
                        </span>
                      </div>
                      <div className="zoom-text-wrapper m-t-20 m-b-40 m-r-20 m-l-20">
                        <span className="text-fw-regular">
                          {IntlUtil.getText(
                            this._intl_ns_suc_home,
                            "content.zoomInfoText3"
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </PageLoader>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  userConsentData: state.identityStore.userConsentData,
});
const mapActionToProps = { setUserConsentRecord };

export default connect(mapStateToProps, mapActionToProps)(ZoomSignin);
